import { API_URL_PRO } from "../config";

export const getWhatsAppLink = async (sessionId, offerId, offerAuxId, pkgType, msisdn) => {
  try {
    const res = await fetch(
      `${API_URL_PRO}anonymous/offer/anonima/${sessionId}?country=usa&requestSource=internacional&offerId=${offerId}&offerAuxId=${offerAuxId}&pkgType=${pkgType}&msisdn=${msisdn}`,
      {
        mode: "no-cors",
      }
    );
    return res.json();
  } catch (err) {
    return err;
  }
};
